import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
} from 'reactstrap';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Alert from 'components/Alert';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import Tabs from 'components/Tabs';
import NavLinkWrapper from 'components/Tabs/NavLinkWrapper';

import {
  campaignSequences,
  campaignInbox,
  campaignInboxWithMessage,
  campaignReports,
  campaignDetailUrl,
  campaignInboxUrl,
  campaignReportsUrl,
} from 'constants/routing';

import {
  getCampaign,
  updateCampaign,
  duplicateCampaign,
  resetCampaign,
} from 'redux/actions/campaignActions';
import { resetMessage } from 'redux/actions/messageActions';
// import ClockOutlineIcon from 'mdi-react/ClockOutlineIcon';
// import TimelineGenerateModal from 'components/modals/TimelineGenerateModal';
import { getAccountEmailConfigs } from 'redux/actions/emailConfigActions';
import ClickToEdit from 'components/forms/EditInline';
import EmailVerificationModal from 'components/modals/EmailVerificationModal';
import { LoadingTitle } from 'components/titles/PageTitle';
import Reports from 'components/Reports/index';
import StatusBadge from 'containers/Campaigns/StatusBadge';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import { getBadgeStatus, STATUS_CHANGEABLE } from 'constants/campaign';
import { Can, AbilityContext } from 'utils/permissions';
import { changeDocumentTitle } from 'utils/hooks';
import { redirectApp } from 'utils/misc';
import { secondaryText } from 'themes/colors';
import SequencesTab from './SequencesTab';
import SettingsModal from './SettingsModal';
import InboxTab from './InboxTab';


class CampaignDetail extends Component {
  static propTypes = {
    getCampaign: PropTypes.func.isRequired,
    updateCampaign: PropTypes.func.isRequired,
    duplicateCampaign: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    campaign: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      id: PropTypes.number,
      name: PropTypes.string,
      status: PropTypes.bool,
      email_service_provider_config: PropTypes.number,
      email_service_provider_config_info: PropTypes.shape({
        email: PropTypes.string,
        is_tracking: PropTypes.bool,
      }),
    }).isRequired,
  };

  constructor() {
    super();
    this.handleEdit = this.handleEdit.bind(this);
    this.state = {
      isEmailVerificationModalOpen: false,
      isConfirmOffModalOpen: false,
      // isTimelineGenerateModalOpen: false,
    };
    // this.toggleIsTimelineGenerateModalOpen = this.toggleIsTimelineGenerateModalOpen.bind(this);
  }

  componentDidMount() {
    const { campaign } = this.props;
    if (!campaign.loaded || parseInt(this.props.match.params.id, 10) !== campaign.id) {
      this.props.getCampaign(this.props.match.params.id);
    }
    this.props.resetMessage();
  }
  componentDidUpdate() {
    const { campaign } = this.props;
    changeDocumentTitle(campaign?.name);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.campaign && this.props.campaign && nextProps.campaign.account &&
      get(nextProps.campaign.email_service_provider_config, 'id')
        !== get(this.props.campaign.email_service_provider_config, 'id')) {
      this.props.getAccountEmailConfigs(nextProps.campaign.account);
    }
  }

  componentWillUnmount() {
    this.props.resetCampaign();
    this.props.resetMessage();
  }

  onStatusChange = status => (
    status ? this.handleStatusChange(status) : this.toggleIsConfirmOffModalOpen()
  );

  handleStatusChange = (status) => {
    this.setState({ isConfirmOffModalOpen: false });
    this.props.updateCampaign(this.props.match.params.id, { status }, true);
  }

  toggleIsConfirmOffModalOpen = () => {
    this.setState({
      isConfirmOffModalOpen: !this.state.isConfirmOffModalOpen,
    });
  }

  handleEdit(campaignName) {
    if (campaignName) {
      this.props.updateCampaign(this.props.match.params.id, { name: campaignName }, true);
    }
  }

  closeEmailVerificationModal = () => {
    const { isEmailVerificationModalOpen } = this.state;
    this.setState({
      isEmailVerificationModalOpen: !isEmailVerificationModalOpen,
    });
  };

  handleDuplicateCampaign = () => {
    this.props.duplicateCampaign(this.props.campaign.id).then((res) => {
      if (res.value.status === 200 || res.value.status === 201) {
        redirectApp(campaignDetailUrl(res.value.data.id));
      } else {
        this.props.getCampaign(this.props.match.params.id);
      }
    });
  };

  toggleIsTimelineGenerateModalOpen = () => (
    this.setState({ isTimelineGenerateModalOpen: !this.state.isTimelineGenerateModalOpen })
  )

  render() {
    const {
      campaign,
    } = this.props;
    const {
      isEmailVerificationModalOpen,
      isConfirmOffModalOpen,
      // isTimelineGenerateModalOpen,
    } = this.state;
    const isCampaignLoaded = parseInt(this.props.match.params.id, 10) === campaign.id && campaign.loaded;
    const emailConfigs = campaign.email_service_provider_configs || [];

    const emailConfigsWithCredentialsSet =
        emailConfigs.filter(config => config.id && config.access_provider !== 'nylas_v3');
    const emailConfigsWithErrors = emailConfigs.filter(config => config.error_message);
    const inboxVisible = this.context.can('see', 'Campaign Inbox');

    return (
      <Container>
        <ConfirmationModal
          open={isConfirmOffModalOpen}
          onBackdropClick={() => this.toggleIsConfirmOffModalOpen()}
          title="Warning"
          confirmLabel="Accept"
          confirmBtnColor="primaryCTA"
          onConfirmClick={() => this.handleStatusChange(false)}
          onCancelClick={() => this.toggleIsConfirmOffModalOpen()}
        >
          <span>Are you sure you want to turn off <strong>&#34;{campaign.name}&#34;</strong>?</span>
          <br />It will continue to poll responses but stop sending emails for all sequences.
        </ConfirmationModal>
        <EmailVerificationModal
          isOpen={isEmailVerificationModalOpen}
          onSuccess={() => this.closeEmailVerificationModal()}
          emailSetting={campaign.email_service_provider_config_info}
        />
        <Row>
          <Col md={12} className="campaign-detail">
            <Row>
              <Col sm={10}>
                <div className="flex">
                  {!isCampaignLoaded ?
                    <LoadingTitle /> :
                    <ClickToEdit
                      wrapperClass="page-title"
                      textClass="account__name_custom"
                      value={campaign.name}
                      endEditing={this.handleEdit}
                      disabled={!this.context.can('edit', 'Campaign  label')}
                    />
                  }

                  <div
                    className={classNames('switch-inline', {
                      visible: isCampaignLoaded,
                      invisible: !isCampaignLoaded,
                    })}
                  >
                    <StatusBadge
                      className="mt-2"
                      status={getBadgeStatus(campaign)}
                      handleStatusChange={
                        this.context.can('toggle', 'Campaign') &&
                          STATUS_CHANGEABLE.includes(getBadgeStatus(campaign)) ?
                          arg => this.onStatusChange(arg) : null
                      }
                    />
                  </div>
                </div>
              </Col>
            </Row>
            {emailConfigsWithCredentialsSet.map(emailConfig => (
              <Alert color="warning">
                <span>The email associated with this campaign, <b>{emailConfig.email}</b>,
                  &nbsp;is legacy account email.&nbsp;&nbsp;
                </span>
              </Alert>
            ))}
            {emailConfigsWithErrors.map(emailConfig => (
              <Alert color="warning">
                <span>The email associated with this campaign, <b>{emailConfig.email}</b>,
                  &nbsp;received an &quot;{emailConfig.error_message}&quot; authentication error.&nbsp;&nbsp;
                </span>
              </Alert>
            ))}
            <Card>
              {isCampaignLoaded &&
                <>
                  <Tabs>
                    <Can I="see" a="Sequence">
                      <NavLinkWrapper
                        exact
                        to={campaignDetailUrl(this.props.match.params.id)}
                        className="nav-link"
                      >
                        Sequences
                      </NavLinkWrapper>
                    </Can>
                    {inboxVisible &&
                      <NavLinkWrapper
                        to={campaignInboxUrl(this.props.match.params.id)}
                        className="nav-link"
                      >
                        Inbox
                      </NavLinkWrapper>
                    }
                    <NavLinkWrapper
                      to={campaignReportsUrl(this.props.match.params.id)}
                      className="nav-link"
                    >
                      Analytics
                    </NavLinkWrapper>
                    <div className="setting-icons">
                      {/* <IconButton onClick={this.toggleIsTimelineGenerateModalOpen}>
                        <ClockOutlineIcon style={{ color: secondaryText, opacity: 0.8 }} />
                      </IconButton> */}
                      {/* <TimelineGenerateModal
                        open={isTimelineGenerateModalOpen}
                        onClose={this.toggleIsTimelineGenerateModalOpen}
                      /> */}
                      <Can I="copy" a="Campaign">
                        <Tooltip title="Duplicate Campaign">
                          <IconButton onClick={this.handleDuplicateCampaign}>
                            <FileCopyIcon style={{ color: secondaryText, opacity: 0.8 }} />
                          </IconButton>
                        </Tooltip>
                      </Can>
                      <Can I="see" a="Campaign Settings">
                        <SettingsModal />
                      </Can>
                    </div>
                  </Tabs>
                  <CardBody>
                    <Switch>
                      <Route path={campaignSequences} exact component={SequencesTab} />
                      <Route
                        path={campaignReports}
                        render={props => (<Reports
                          {...props}
                          initFilterParams={this.props.campaign.id ? {
                            campaign__id: [{ value: this.props.campaign.id }],
                          } : {}}
                          hideCampaignsFilter
                          hideCampaignManagersFilter
                          hidePlanTypesFilter
                          hideAccountsFilter
                          isCampaignReportsTab
                        />)}
                      />
                      <Route exact path={campaignInbox} component={InboxTab} />
                      <Route path={campaignInboxWithMessage} component={InboxTab} />
                      <Redirect to="/404" />
                    </Switch>
                  </CardBody>
                </>
              }
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

CampaignDetail.contextType = AbilityContext;

export default connect(
  state => ({
    campaign: state.campaign,
    accountEmailConfig: state.accountEmailConfig,
    accountEmailConfigs: state.accountEmailConfigs,
    config: state.config,
    accounts: state.accounts,
  }),
  {
    getCampaign, updateCampaign, getAccountEmailConfigs, duplicateCampaign, resetCampaign, resetMessage,
  },
)((withNamespaces('common')(CampaignDetail)));
